<template>
	<div>
		<div class="sf-search-layout__body__container">
			<sf-search-layout>
				<el-row :gutter="20">
					<el-col :span="5">
						<div class="sf-input-group-wrapper">
							<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC001057') }}</span>
							<el-date-picker
								v-model="searchDateRange"
								type="daterange"
								align="right"
								:start-placeholder="getMessage_('QWCC000920')"
								:end-placeholder="getMessage_('QWCC000954')"
								range-separator="~"
							/>
						</div>
					</el-col>
					<el-col :span="4">
						<search-input
							:label="getMessage_('QWCC000956')"
							paramKey="partNo"
							@commInput="setSearchParam"
							:clearable="false"
							:propData="searchParams.partNo"
						>
							<template v-slot:icon> <i class="icon-sf-search search-icon" @click="onPartPopup"></i></template>
						</search-input>
					</el-col>
					<el-col :span="4">
						<select-combo
							:label="getMessage_('QWCC001464')"
							paramKey="occuPlCd"
							:options="occuPlList"
							:propData="searchParams.occuPlCd"
							@commChange="setSearchParam"
						></select-combo>
					</el-col>
				</el-row>
				<template slot="button">
					<sf-button line icon="search" :onClick="searchList" v-if="isButton_(scrId, 'CR')">
						{{ getButtonMsg_(scrId, 'CR') }}
					</sf-button>
				</template>
			</sf-search-layout>
		</div>
		<part-mng-popup ref="partMngPopup" @SendData="sendData" :scrId="scrId"></part-mng-popup>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import SelectCombo from '@qms/Components/SelectCombo';
import SearchInput from '@qms/Components/SearchInput';
import PartMngPopup from '@qms/comm/commpopup/PartMngPopup/PartMngPopup.vue';
export default {
	props: { scrId: { type: String, default: '' } },
	data() {
		return {
			searchDateRange: []
		};
	},
	components: { SelectCombo, SearchInput, PartMngPopup },
	async created() {
		try {
			this.searchDateRange = this.getSearchDates_;
			await this.getCommCodes_({ key: 'occuPlList', codeType: 'OCCU_PL' });
			await this.searchList();
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error?.message
			});
		}
	},
	watch: {
		async searchDateRange(newValue) {
			if (newValue == null) {
				this.$sf_toast({
					type: 'error',
					message: this.getMessage_('QWCC001668')
					// 기간 검색입력은 필수 입니다.
				});
				let strDt = this.$moment().subtract(1, 'month');
				let endDt = this.$moment();
				this.searchDateRange = [strDt.format('YYYY-MM-DD'), endDt.format('YYYY-MM-DD')];
				this.setSearchParam_({ key: 'strDt', value: strDt.format('YYYYMMDD') });
				this.setSearchParam_({ key: 'endDt', value: endDt.format('YYYYMMDD') });
			}
			if (newValue?.length == 2) {
				let strDt = this.$moment(this.searchDateRange[0]);
				let endDt = this.$moment(this.searchDateRange[1]);
				const diffDays = this.$moment(endDt).diff(strDt, 'days');
				if (diffDays > 32) {
					strDt = this.$moment().subtract(30, 'days');
					endDt = this.$moment();
					this.$sf_toast({
						type: 'error',
						message: this.$sf_formatString(this.getMessage_('QWCC001235'), ['31']) //일 이상 검색할 수 없습니다.
					});
					this.searchDateRange = [strDt.format('YYYY-MM-DD'), endDt.format('YYYY-MM-DD')];
				}
				this.setSearchParam_({ key: 'strDt', value: strDt.format('YYYYMMDD') });
				this.setSearchParam_({ key: 'endDt', value: endDt.format('YYYYMMDD') });
			}
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		setSearchParam(param) {
			this.setSearchParam_(param);
		},
		onPartPopup() {
			this.$refs.partMngPopup.open(this.searchParams.partNo);
		},
		sendData({ partNo }) {
			this.setSearchParam_({ key: 'partNo', value: partNo });
		},
		async searchList() {
			try {
				this.$sf_toggleLoading(true);
				await this.getList_();
			} catch (error) {
				this.$sf_toast({
					type: 'error',
					message: error?.message
				});
			} finally {
				this.$emit('doLoad');
				this.$sf_toggleLoading(false);
			}
		}
	},
	computed: { ...rootComputed, ...serviceComputed }
};
</script>

<style></style>
